export default {"src":"/_next/static/media/mobileDropDownIcon.32ee2224.svg","height":11,"width":20,"blurWidth":0,"blurHeight":0};